import React from 'react';
import uniqueId from 'lodash/uniqueId';
import identity from 'lodash/identity';
import Label from '../Label';

import './FormGroup.less';
import { useState } from 'react';

/**
 *
 * @param {{
 * id?: string;
 * label?: React.ReactNode;
 * required?: boolean;
 * classNameWrapper?:string;
 * classNameControlWrapper?:string;
 * controlRender?(params:{ id:string; required:boolean; }):React.ReactNode;
 * postControlSlot?:React.ReactNode|((params:{ id:string; required:boolean; })=>React.ReactNode);
 * invalid?: boolean;
 * horizontal?: boolean;
 * children?: React.ReactNode|React.ReactNode[];
 * metadata?:Record<string, any>;
 * labelSize?:number;
 * alignWithControlBaseline?:boolean;
 * ctrlSize?:number;
 * isGroupOfControls?:boolean;
 * labelNoHtmlfor?:boolean;
 * hidden?:boolean;
 * }} props
 * @returns {React.ReactElement}
 */
export const FormGroup = (props) => {
  const {
    label,
    controlRender,
    classNameControlWrapper,
    classNameWrapper,
    invalid,
    required = false,
    horizontal,
    children,
    metadata,
    labelSize = 3,
    ctrlSize,
    isGroupOfControls,
    labelNoHtmlfor,
    postControlSlot,
    alignWithControlBaseline,
    hidden,
  } = props;

  const [controlUID] = useState(props.id || uniqueId('lsn_eval_control_'));

  const labelClass = `col-${labelSize}`;
  const ctrlClass = `col-${ctrlSize ?? (12 - labelSize)}`;
  const htmlFor = labelNoHtmlfor ? void 0 : isGroupOfControls ? `${controlUID}_0` : controlUID;

  const classNames = {
    group: [
      "form-group lsn-form-group",
      (horizontal ? 'horizontal columns' : 'vertical columns'),
      (invalid ? 'has-error' : null),
      alignWithControlBaseline ? 'align-with-baseline' : '',
      classNameWrapper,
      hidden ? 'hidden d-none' : '',
    ].filter(identity).join(' '),
    label: [
      'lsn-group-label',
      'column',
      horizontal && controlRender ? `${labelClass} col-md-12` : "col-12",
      "text-left",
    ].filter(identity).join(' '),
    control: [
      'lsn-group-control',
      'column',
      horizontal && label ? `${ctrlClass} col-md-12` : "col-12",
      "text-left",
      "p-relative",
      classNameControlWrapper
    ].filter(identity).join(' '),
  };

  const renderLabel = () => (<div className={classNames.label}>{
    <Label required={required} text={label} htmlFor={htmlFor} className={`${horizontal ? '' : 'no-padding'}`} />
  }</div>);

  const renderControl = () => {
    const controlParams = { id: controlUID, required, horizontal };
    const controlItem = controlRender?.(controlParams);
    return <div className={classNames.control}>{children}{controlItem}</div>
  };

  const wrapperDataAttr = Object.keys(metadata ?? {})?.reduce((r, key) => ({ ...r, [`data-${key}`]: metadata?.[key] ?? '' }), {}) ?? {};

  return (
    <div className={classNames.group} {...wrapperDataAttr}>
      {label ? renderLabel() : null}
      {renderControl()}
      {typeof postControlSlot === 'function' ? postControlSlot({ id: controlUID, required }) : postControlSlot}
    </div>
  )
};

export default FormGroup;
